/* logger.js
A simple logging utility that sends logs to the backend for storage and analysis.
*/

const API_URL = process.env.REACT_APP_SERVER_URL;

const sendToBackend = (level, msg, data) => {
  try {
    fetch(`${API_URL}/logs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "secure123",
      },
      body: JSON.stringify({
        level,
        msg,
        data,
        roomId: data?.roomId || null,
        user: data?.user || null,
        time: new Date().toISOString(),
      }),
    });
  } catch (err) {
    console.error("Log send failed", err);
  }
};

export const logger = {
  info: (msg, data) => {
    console.log("[INFO]", msg, data || "");
    sendToBackend("info", msg, data);
  },

  warn: (msg, data) => {
    console.warn("[WARN]", msg, data || "");
    sendToBackend("warn", msg, data);
  },

  error: (msg, data) => {
    console.error("[ERROR]", msg, data || "");
    sendToBackend("error", msg, data);
  },

  debug: (msg, data) => {
    console.debug("[DEBUG]", msg, data || "");
    sendToBackend("debug", msg, data);
  },
};
